import { client } from "@/api/client";
import interceptors from "@/api/interceptor";

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);


function getSupportBank() {
	return client.get("options/support-bank");
}

function getCourier() {
	return client.get("options/courier");
}

function getOngkir(params) {
	return client.get("common/ongkir", {
		params: params,
	});
}

function getProvince() {
	return client.get("options/area-province");
}

function getCity(params) {
	return client.get("options/area-city", {
		params: params,
	});
}
function getTipeMember(params) {
	return client.get("product/tipe-member", {
		params: params,
	});
}

function getSubdistrict(params) {
	return client.get("options/area-subdistrict", {
		params: params,
	});
}

function getBankList(params) {
	return client.get("options/bank", {
		params: params,
	});
}

function getBankAccountList(params) {
	return client.get("options/bank-account", {
		params: params,
	});
}

function getPaymentMethodList(params) {
	return client.get("options/payment-method", {
		params: params,
	});
}

export default {
	getCourier,
	getOngkir,
	getProvince,
	getCity,
	getSubdistrict,
	getBankList,
	getBankAccountList,
	getTipeMember,
	getPaymentMethodList,
	getSupportBank
};